import ReactMarkdown from 'react-markdown'
import QualityMetricsCard from './QualityMetricsCard'

export default function ComprehensiveAnswerCard({ data, loading }) {
  if (loading) {
    return (
      <div className="card bg-base-100 shadow-xl">
        <div className="card-body">
          <h2 className="card-title">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75M18 15v3.75a2.25 2.25 0 01-2.25 2.25h-10.5A2.25 2.25 0 013 16.5V4.125C0 2.953.953 2.25 2.25 2.25h9.75c1.125 0 2.25.563 2.25 1.875V6.75l3.75 3.75" />
            </svg>
            Comprehensive Answer
          </h2>
          <div className="flex justify-center py-4">
            <span className="loading loading-spinner loading-md"></span>
          </div>
        </div>
      </div>
    )
  }

  if (!data) return null

  // Only render Quality Metrics Card if it exists
  return (
    <>
      {data.quality_metrics && (
        <QualityMetricsCard data={data.quality_metrics} loading={false} />
      )}
    </>
  )
}